export function formatMegabytes(bytesReceived = 0, bytesSent = 0) {
  const mb =
    bytesReceived + bytesSent
      ? Math.round(((bytesReceived + bytesSent) * 1e-6 + Number.EPSILON) * 100) / 100
      : 0;
  const mbText = mb ? `${mb} MB` : 'pending';

  return mbText;
}

export function formatMinutesSeconds(seconds: number) {
  const minutesSeconds =
    ('0' + Math.floor(seconds / 60)).slice(-2) + ':' + ('0' + Math.floor(seconds % 60)).slice(-2);

  return minutesSeconds;
}
